// extracted by mini-css-extract-plugin
module.exports = {"container":"DownloadsListItemSkeleton_container__17iiR","img":"DownloadsListItemSkeleton_img__3qT4L","mainLine":"DownloadsListItemSkeleton_mainLine__QTnV3"};